import React, { ReactNode } from 'react';

import MUIProvider from '~/contexts/MUIProvider';

import { Box, SxProps } from '@mui/material';

import PageAreas from './PageAreas';
import { unsupportedComponentStyle } from './pageSupportingStyles';

const supportedAreas = Object.values(PageAreas);

const rootStyleLeftSidebar: SxProps = {
  display: 'grid',
  gridTemplateAreas: {
    xs: `"${PageAreas.header}"
         "${PageAreas.startSide}"
         "${PageAreas.body}"`,
    sm: `"${PageAreas.header}"
         "${PageAreas.startSide}"
         "${PageAreas.body}"`,
    md: `"${PageAreas.header} ${PageAreas.header}"
         "${PageAreas.startSide} ${PageAreas.body}"`,
  },
  gridTemplateColumns: {
    xs: '1fr',
    sm: '1fr',
    md: 'minmax(auto, 300px) 1fr',
  },
  gridTemplateRows: {
    xs: 'auto auto 1fr auto',
    sm: 'auto auto 1fr auto',
    md: 'auto 1fr',
  },
  minHeight: '100vh',
  height: '100vh',
  overflow: 'hidden',
  paddingRight: { xs: 2, sm: 2, md: 2 },
  '& > *': { minWidth: 0 },
  [`> :not(${supportedAreas.map((a) => `.${a}`).join(', ')})`]: unsupportedComponentStyle(
    'UNSUPPORTED PAGE LAYOUT COMPONENT',
  ),
  [`& .${PageAreas.body}`]: {
    overflowY: 'auto',
    height: '100%',
    minHeight: 0,
  },
  [`& .${PageAreas.startSide}`]: {
    position: 'sticky',
    top: 0,
    height: '100vh',
    overflowY: 'auto',
    alignSelf: 'start',
  },
};

const rootStyleLeftAndRightSidebar: SxProps = {
  display: 'grid',
  gridTemplateAreas: {
    xs: `"${PageAreas.header}"
         "${PageAreas.startSide}"
         "${PageAreas.body}"
         "${PageAreas.endSide}"`,
    sm: `"${PageAreas.header}"
         "${PageAreas.startSide}"
         "${PageAreas.body}"
         "${PageAreas.endSide}"`,
    md: `"${PageAreas.header} ${PageAreas.header} ${PageAreas.header}"
         "${PageAreas.startSide} ${PageAreas.body} ${PageAreas.endSide}"`,
  },
  gridTemplateColumns: {
    xs: '1fr',
    sm: '1fr',
    md: 'minmax(auto, 300px) 1fr minmax(auto, 300px)',
  },
  gridTemplateRows: {
    xs: 'auto auto 1fr auto',
    sm: 'auto auto 1fr auto',
    md: 'auto 1fr',
  },
  minHeight: '100vh',
  height: '100vh',
  overflow: 'hidden',
  paddingRight: { xs: 2, sm: 2, md: 2 },
  '& > *': { minWidth: 0 },
  [`> :not(${supportedAreas.map((a) => `.${a}`).join(', ')})`]: unsupportedComponentStyle(
    'UNSUPPORTED PAGE LAYOUT COMPONENT',
  ),
  [`& .${PageAreas.body}`]: {
    overflowY: 'auto',
    height: '100%',
    minHeight: 0,
  },
  [`& .${PageAreas.startSide}`]: {
    position: 'sticky',
    top: 0,
    height: '100vh',
    overflowY: 'auto',
    alignSelf: 'start',
  },
  [`& .${PageAreas.endSide}`]: {
    position: 'sticky',
    top: 0,
    height: '100vh',
    overflowY: 'auto',
    alignSelf: 'start',
  },
};

interface Props {
  children: ReactNode;
  hasLeftSidebar?: boolean;
  hasRightSidebar?: boolean;
}

function PageLayout({ children, hasLeftSidebar, hasRightSidebar }: Props) {
  return (
    <MUIProvider>
      <Box
        className="page-layout"
        sx={hasLeftSidebar && hasRightSidebar ? rootStyleLeftAndRightSidebar : rootStyleLeftSidebar}
      >
        {children}
      </Box>
    </MUIProvider>
  );
}

export default PageLayout;
